/**
 * Logger for CrossDomainStorage with configurable log levels
 */
export class Logger {
    private static readonly LOG_LEVELS = {
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
        NONE: 4
    } as const;

    private logLevel: number;
    private context: string;

    constructor(context: string, stage: string = 'prod') {
        this.context = context;
        // Set log level based on stage
        this.logLevel = stage === 'prod' ? Logger.LOG_LEVELS.ERROR : Logger.LOG_LEVELS.INFO;
    }

    private formatMessage(level: string, message: string, ...args: any[]): void {
        const timestamp = new Date().toISOString();
        const formattedMessage = `[${timestamp}] [${level}] [${this.context}] ${message}`;

        if (args.length > 0) {
            console.log(formattedMessage, ...args);
        } else {
            console.log(formattedMessage);
        }
    }

    debug(message: string, ...args: any[]): void {
        if (this.logLevel <= Logger.LOG_LEVELS.DEBUG) {
            this.formatMessage('DEBUG', message, ...args);
        }
    }

    info(message: string, ...args: any[]): void {
        if (this.logLevel <= Logger.LOG_LEVELS.INFO) {
            this.formatMessage('INFO', message, ...args);
        }
    }

    warn(message: string, ...args: any[]): void {
        if (this.logLevel <= Logger.LOG_LEVELS.WARN) {
            const timestamp = new Date().toISOString();
            const formattedMessage = `[${timestamp}] [WARN] [${this.context}] ${message}`;
            if (args.length > 0) {
                console.warn(formattedMessage, ...args);
            } else {
                console.warn(formattedMessage);
            }
        }
    }

    error(message: string, ...args: any[]): void {
        if (this.logLevel <= Logger.LOG_LEVELS.ERROR) {
            const timestamp = new Date().toISOString();
            const formattedMessage = `[${timestamp}] [ERROR] [${this.context}] ${message}`;
            if (args.length > 0) {
                console.error(formattedMessage, ...args);
            } else {
                console.error(formattedMessage);
            }
        }
    }

    setLogLevel(level: keyof typeof Logger.LOG_LEVELS): void {
        this.logLevel = Logger.LOG_LEVELS[level];
    }
}
